var _path, _path2, _path3, _defs, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActionHoldAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.17 43.019 26.966 23.24l-2.21-2.21L4.98 38.83a2.965 2.965 0 0 0-.112 4.3 2.964 2.964 0 0 0 4.3-.112z",
    fill: "#ad3f16"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#751b0b",
    d: "m41.372 19.968-13.299-13.3-8.364 8.365 13.299 13.3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m30.838 26.132 8.368-8.368c.6-.6.6-1.572 0-2.172L32.472 8.86c-.6-.6-1.572-.6-2.172 0l-8.367 8.368c-.6.6-.6 1.572 0 2.172l6.733 6.733c.6.6 1.572.6 2.172 0zM19.742 14.998l8.33-8.33c.611-.611.611-1.6 0-2.21a1.56 1.56 0 0 0-2.21 0l-8.33 8.33a1.564 1.564 0 0 0 2.21 2.21zm15.47 15.469 8.33-8.33c.61-.611.61-1.6 0-2.21a1.56 1.56 0 0 0-2.21 0l-8.33 8.33a1.561 1.561 0 0 0 0 2.21 1.56 1.56 0 0 0 2.21 0z",
    fill: "#d6742d"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    y2: 38,
    y1: 38,
    x2: 48,
    x1: 28,
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#21ad64",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#088242",
    offset: 1
  })))), /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 38,
    r: 10,
    fill: "url(#a)",
    style: {
      fill: "url(#a)"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M38.5 43h-1a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M33 38.5v-1a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionHoldAdd);
export default __webpack_public_path__ + "static/media/actionHoldAdd.3497668a34d7648fb7ff7230e4161640.svg";
export { ForwardRef as ReactComponent };